var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpSkirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 9l5-5h14l5 5l7 26s-3 9-19 9s-19-9-19-9zm1 33l4-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 35s3 9 19 9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpSkirt);
export default __webpack_public_path__ + "static/media/icon-ip-skirt.6f0891d4c33a14bda730fd3bad55d92f.svg";
export { ForwardRef as ReactComponent };